// Biodeal Animal Health — Product catalogue data
// Source: BAH Product Catalogue A5 (August 2025) — verbatim brand names preserved.
// DO NOT auto-correct, respell, or standardize Biodeal brand/product names.
//
// `image` is a path to the rendered catalogue page where the product appears
// (extracted from the uploaded PDF at /app/frontend/public/catalogue/p-XX.jpg).

export const PRODUCT_CATEGORIES = [
  { id: "dewormers", label: "Dewormers" },
  { id: "antibiotics", label: "Antibiotics" },
  { id: "supplements", label: "Supplements & Nutrition" },
  { id: "clean-protect", label: "Clean & Protect (Biosecurity)" },
  { id: "skin-care", label: "Skin & Udder Care" },
  { id: "digestives", label: "Digestives" },
  { id: "companion", label: "Companion Animal" },
  { id: "consumables", label: "Consumables" },
];

export const SPECIES = [
  { id: "poultry", label: "Poultry" },
  { id: "cattle", label: "Cattle" },
  { id: "sheep-goats", label: "Sheep & Goats" },
  { id: "pigs", label: "Pigs" },
  { id: "camels", label: "Camels" },
  { id: "dogs-cats", label: "Dogs & Cats" },
  { id: "biosecurity", label: "General Farm / Clinic Biosecurity" },
  { id: "cold-chain", label: "Vaccine / Cold Chain" },
];

export const CHALLENGES = [
  { id: "respiratory", label: "Respiratory / bacterial support" },
  { id: "worms", label: "Worms / parasites" },
  { id: "stress", label: "Stress / recovery / nutrition" },
  { id: "growth", label: "Growth / productivity" },
  { id: "udder", label: "Udder / teat care" },
  { id: "wounds", label: "Wounds / skin care" },
  { id: "biosecurity", label: "Biosecurity / disinfection" },
  { id: "handling", label: "Handling / field instruments" },
  { id: "cold-storage", label: "Vaccine storage / transport" },
];

export const PRODUCTS = [
  // ---------------- DEWORMERS ----------------
  {
    id: "wormizan-plus",
    name: "WORMIZAN PLUS",
    category: "dewormers",
    species: ["camels", "sheep-goats"],
    challenges: ["worms", "growth"],
    image: "/catalogue/p-05.jpg",
    active_ingredient: "Levamisole 1.5%w/v + Oxyclozanide 3.0%w/v",
    use_summary:
      "Eradicates all worms and liver flukes. Aids in higher milk yields and rapid weight gain.",
    pack_sizes: "5 litre, 1 litre, 500ml, 150ml",
    field_note:
      "Use for all camels, sheep and goats. Safe in livestock of all ages.",
    safety: "FOR VETERINARY USE ONLY. Use as directed by a veterinarian.",
    badges: ["Veterinary use only", "Safe all ages"],
  },
  {
    id: "wormizan-super",
    name: "WORMIZAN SUPER",
    category: "dewormers",
    species: ["cattle", "camels", "sheep-goats"],
    challenges: ["worms", "growth"],
    image: "/catalogue/p-05.jpg",
    active_ingredient: "Levamisole 3.0%w/v + Oxyclozanide 6.0%w/v",
    use_summary:
      "Eradicates all worms and liver flukes. Healthier animals leading to rapid weight gain and increased reproduction. Best selling formula.",
    pack_sizes: "5 litre, 1 litre, 500ml, 150ml",
    field_note:
      "Double strength — economical: use less on more animals. Cattle, camels, sheep and goats.",
    safety: "FOR VETERINARY USE ONLY. Safe in livestock of all ages.",
    badges: ["Best seller", "Double strength"],
  },
  {
    id: "levazan-liquid",
    name: "LEVAZAN LIQUID DEWORMER",
    category: "dewormers",
    species: ["cattle", "camels", "sheep-goats"],
    challenges: ["worms"],
    image: "/catalogue/p-05.jpg",
    active_ingredient: "Levamisole 1.5%w/v",
    use_summary:
      "Best value formulation for the control and elimination of worms.",
    pack_sizes: "5 litre, 1 litre, 500ml, 150ml",
    field_note:
      "Effective dosing at an affordable price. Cattle, camels, sheep and goats.",
    safety: "SAFE IN ANIMALS OF ALL AGES. FOR VETERINARY USE ONLY.",
    badges: ["Value formulation"],
  },
  {
    id: "piparex-powder",
    name: "PIPAREX POWDER",
    category: "dewormers",
    species: ["pigs", "poultry"],
    challenges: ["worms"],
    image: "/catalogue/p-06.jpg",
    active_ingredient: "Piperazine Citrate 0.35gm/gm",
    use_summary:
      "Oral anthelmintic powder that instantly expels roundworms.",
    pack_sizes: "250gm, 100gm & 30gm",
    field_note:
      "For use in pigs, poultry, horses, calves and donkeys.",
    safety: "Use as directed by a veterinarian.",
  },
  {
    id: "popvet-total",
    name: "POPVET TOTAL",
    category: "companion",
    species: ["dogs-cats"],
    challenges: ["worms"],
    image: "/catalogue/p-06.jpg",
    active_ingredient:
      "Pyrantel pamoate 143mg + Oxantel Pamoate 543mg + Praziquantel 50mg",
    use_summary:
      "Broad spectrum dewormer for dogs. For the treatment and control of roundworms, hookworms, whipworms and all tapeworms — including Hydatids — in dogs.",
    pack_sizes: "Tablets in blister packs, 25 x 4's",
    field_note:
      "Scored tablets — break down to 1¼ for a pup of 2.5 kg, up to 4 tablets for a 40 kg dog. Treat once every three months. Weigh dogs before every treatment.",
    safety:
      "VETERINARY — NOT FOR HUMAN USE. Safe for puppies from 2 weeks of age, pregnant & lactating bitches, working dogs, greyhounds and senior dogs.",
    badges: ["Believe in Better", "Broad spectrum"],
  },
  {
    id: "levazan-poultry",
    name: "LEVAZAN POULTRY",
    category: "dewormers",
    species: ["poultry"],
    challenges: ["worms"],
    image: "/catalogue/p-06.jpg",
    active_ingredient: "Levamisole 7.5% w/v",
    use_summary:
      "The trusted poultry dewormer. Effective worm eradication in all poultry.",
    pack_sizes: "1 litre, 100ml & 30ml",
    field_note:
      "Use with BIOTRIM VET and BIOTRIM VET PLUS for a complete poultry health programme.",
    safety: "Use as directed by a veterinarian.",
  },

  // ---------------- ANTIBIOTICS ----------------
  {
    id: "abezole",
    name: "ABEZOLE 2.5% W/V & 10% W/V",
    category: "dewormers",
    species: ["cattle", "camels", "sheep-goats"],
    challenges: ["worms", "growth"],
    image: "/catalogue/p-07.jpg",
    active_ingredient: "Albendazole 2.5%w/v and 10%w/v",
    use_summary:
      "Broad spectrum anthelmintic to eradicate all worms. Used regularly to support milk yield and weight gain. The choice dewormer for farmers around the country.",
    pack_sizes:
      "Abezole 2.5%w/v — 120ml, 250ml, 500ml, 1 litre. Abezole 10%w/v — 40ml, 120ml, 500ml, 1 litre.",
    field_note: "Use for all cattle, camels, sheep and goats.",
    safety: "Use as directed by a veterinarian.",
    badges: ["Broad spectrum"],
  },
  {
    id: "biotrim-vet",
    name: "BIOTRIM VET ORAL POWDER",
    category: "antibiotics",
    species: ["poultry"],
    challenges: ["respiratory"],
    image: "/catalogue/p-07.jpg",
    active_ingredient:
      "Trimethoprim 2%w/w + Sulphamethoxazole 10%w/w",
    use_summary:
      "Anti-bacterial for prevention and treatment of coccidiosis, infectious coryza, chronic respiratory conditions, E. Coli and Salmonella infections.",
    pack_sizes: "1kg, 500gm, 250gm, 100gm & 30gm",
    field_note:
      "Water dispersible powder. Dose: 5gm in 5 litres for 3 – 5 days or as directed by a veterinarian.",
    safety: "FOR VETERINARY USE ONLY. Use as directed by a veterinarian.",
    badges: ["Water dispersible"],
  },
  {
    id: "biotrim-vet-plus",
    name: "BIOTRIM VET PLUS ORAL POWDER",
    category: "antibiotics",
    species: ["poultry"],
    challenges: ["respiratory", "stress"],
    image: "/catalogue/p-07.jpg",
    active_ingredient:
      "Trimethoprim 2%w/w + Sulphamethoxazole 10%w/w + Vitamin A + Vitamin K3",
    use_summary:
      "Anti-bacterial action as for Biotrim Vet with added healing aid. Vitamin A repairs damaged epithelial cells in the stomach; Vitamin K stops bleeding fast. Faster recovery, improved appetite and weight gain.",
    pack_sizes: "1kg, 250gm, 100gm & 30gm",
    field_note: "CO-TRIMOXAZOLE WATER DISPERSIBLE POWDER.",
    safety: "FOR VETERINARY USE ONLY. Use as directed by a veterinarian.",
    badges: ["Best seller"],
  },
  {
    id: "doxy-tyl",
    name: "DOXY-TYL VET POWDER",
    category: "antibiotics",
    species: ["cattle", "poultry", "pigs"],
    challenges: ["respiratory"],
    image: "/catalogue/p-08.jpg",
    active_ingredient: "Doxycycline 200mg + Tylosine Tartrate 100mg",
    use_summary:
      "Unique combination of antibiotics to treat acute and chronic respiratory diseases in cows, poultry and pigs. Starts working within 2 hours.",
    pack_sizes: "1kg, 100gm & 30gm",
    field_note: "Manufactured in Kenya ONLY by Biodeal.",
    safety: "FOR VETERINARY USE ONLY. Use as directed by a veterinarian.",
    badges: ["Made in Kenya"],
  },
  {
    id: "cloben-g",
    name: "Cloben G Vet Cream",
    category: "skin-care",
    species: ["cattle", "sheep-goats", "dogs-cats"],
    challenges: ["wounds", "udder"],
    image: "/catalogue/p-08.jpg",
    active_ingredient:
      "Clotrimazole 1%w/w + Gentamicin 1%w/w + Betamethasone 0.1%w/w",
    use_summary:
      "Effective antimicrobial combination formula. Use for treatment of fungal and bacterial skin infections with inflammation in all animals. Also used for uterine application.",
    pack_sizes: "15gm",
    field_note: "Apply as directed by a veterinarian.",
    safety: "FOR EXTERNAL USE ONLY. Use as directed by a veterinarian.",
  },

  // ---------------- SUPPLEMENTS ----------------
  {
    id: "jointguard",
    name: "JointGuard — Cats & Dogs",
    category: "companion",
    species: ["dogs-cats"],
    challenges: ["stress", "growth"],
    image: "/catalogue/p-08.jpg",
    active_ingredient:
      "Glucosamine Hydrochloride 500mg + Chondroitin 400mg + Methyl Sulphonyl Methane 200mg",
    use_summary:
      "Maintains and improves joint health for healthy mobility. Aids in healing of injuries associated with connective tissue and ligament.",
    pack_sizes: "30 Tablets",
    field_note: "Pleasant flavour for pets. Made by Biodeal only.",
    safety: "Use as directed by a veterinarian.",
  },
  {
    id: "dcp",
    name: "Di-Calcium Phosphate (DCP)",
    category: "supplements",
    species: ["cattle", "poultry", "sheep-goats"],
    challenges: ["growth"],
    image: "/catalogue/p-09.jpg",
    active_ingredient: "Calcium and Phosphate salts",
    use_summary:
      "Aids healthier growth of animals. For poultry, gives stronger egg shells, prevents cannibalism and feather pecking, builds stronger bones.",
    pack_sizes: "1250gm & 500gm",
    field_note:
      "Use in symptoms related to deficiency of Calcium and Phosphate.",
    safety: "Effective mineral supplement.",
  },
  {
    id: "bio-start",
    name: "Bio-Start",
    category: "supplements",
    species: ["poultry"],
    challenges: ["growth", "stress"],
    image: "/catalogue/p-09.jpg",
    active_ingredient: "Multivitamins and minerals",
    use_summary:
      "For strong and healthy chicks. Provides all nutrients and essential vitamins for fast growth between day 1 – 14. Boosts immune system, supports complete nutritional support, reduces tedious mixing work.",
    pack_sizes: "1kg, 100gm & 30gm",
    field_note: "For chicks.",
    safety: "Use as directed by a veterinarian.",
    badges: ["Day 1 – 14"],
  },
  {
    id: "vitavet-ws",
    name: "VitaVet WS",
    category: "supplements",
    species: ["cattle", "poultry", "sheep-goats"],
    challenges: ["stress", "growth"],
    image: "/catalogue/p-09.jpg",
    active_ingredient: "Essential vitamins (water soluble multi-vitamin)",
    use_summary:
      "Vitamins to keep animals healthy. Helps animals recover faster from illness and disease. Aids weight gain.",
    pack_sizes: "1kg & 100gm",
    field_note: "Healthy livestock = healthy profits.",
    safety: "FOR VETERINARY USE ONLY.",
  },
  // Additional Biomix range from user brief (catalogue data sheet on request)
  {
    id: "biomix-extra-egg",
    name: "BIOMIX Extra Egg",
    category: "supplements",
    species: ["poultry"],
    challenges: ["growth"],
    active_ingredient: "Detailed composition available on request.",
    use_summary:
      "Layer nutritional supplement from the Biomix range. Full product sheet available from the Biodeal Animal Health technical team.",
    pack_sizes: "Available — request from technical team.",
    field_note: "For laying poultry.",
    safety: "Use as directed by a veterinarian.",
    sheet_on_request: true,
  },
  {
    id: "biomix-broiler-booster",
    name: "BIOMIX BROILER BOOSTER",
    category: "supplements",
    species: ["poultry"],
    challenges: ["growth"],
    active_ingredient: "Detailed composition available on request.",
    use_summary:
      "Broiler growth and performance supplement from the Biomix range. Full product sheet available from the Biodeal Animal Health technical team.",
    pack_sizes: "Available — request from technical team.",
    field_note: "For broiler poultry.",
    safety: "Use as directed by a veterinarian.",
    sheet_on_request: true,
  },
  {
    id: "biomix-antistress",
    name: "BIOMIX ANTISTRESS",
    category: "supplements",
    species: ["poultry", "cattle"],
    challenges: ["stress"],
    active_ingredient: "Detailed composition available on request.",
    use_summary:
      "Anti-stress and recovery support from the Biomix range. Full product sheet available from the Biodeal Animal Health technical team.",
    pack_sizes: "Available — request from technical team.",
    field_note: "For periods of stress, transport, vaccination or recovery.",
    safety: "Use as directed by a veterinarian.",
    sheet_on_request: true,
  },
  {
    id: "biomix-nutrigold",
    name: "BIOMIX NUTRIGOLD",
    category: "supplements",
    species: ["poultry", "cattle"],
    challenges: ["growth", "stress"],
    active_ingredient: "Detailed composition available on request.",
    use_summary:
      "Premium nutritional supplement from the Biomix range. Full product sheet available from the Biodeal Animal Health technical team.",
    pack_sizes: "Available — request from technical team.",
    field_note: "For productivity support.",
    safety: "Use as directed by a veterinarian.",
    sheet_on_request: true,
  },

  // ---------------- CLEAN AND PROTECT ----------------
  {
    id: "omnicide",
    name: "OMNICIDE",
    category: "clean-protect",
    species: ["biosecurity"],
    challenges: ["biosecurity"],
    image: "/catalogue/p-10.jpg",
    active_ingredient:
      "Glutaraldehyde + Coco Benzyl Dimethyl Ammonium Chloride",
    use_summary:
      "For complete biosecurity. Effective against bacteria, fungi, virus and mould. Does not lose activity in organic matter.",
    pack_sizes: "5 litre, 1 litre, 500ml and 100ml",
    field_note:
      "Use for disinfection of walls, floors, equipment, baths, drinking systems, vehicles, fumigation, cool pads, litter and slaughterhouses.",
    safety: "Handle with care. Follow label directions.",
    badges: ["Complete biosecurity"],
  },
  {
    id: "kleenol",
    name: "Kleenol",
    category: "clean-protect",
    species: ["biosecurity"],
    challenges: ["biosecurity"],
    image: "/catalogue/p-10.jpg",
    active_ingredient: "Phenols 7 – 12 %w/v",
    use_summary:
      "Strong disinfectant fluid. Effective disinfection of farm structures and footbaths. Prevents spread of disease, deaths and infections.",
    pack_sizes: "5 litres",
    field_note:
      "The leading brand in disinfection and infection control.",
    safety: "POISON. Handle with care. Keep away from children.",
  },
  {
    id: "biodine",
    name: "Biodine",
    category: "clean-protect",
    species: ["biosecurity", "cattle", "sheep-goats"],
    challenges: ["biosecurity", "wounds"],
    image: "/catalogue/p-10.jpg",
    active_ingredient: "Povidone Iodine B.P. 5% w/v & B.P. 10% w/v",
    use_summary:
      "Effective antimicrobial. Used for cleaning and disinfection of wounds. Used for uterine irrigation.",
    pack_sizes:
      "5% — 100ml, 500ml. 10% — 100ml, 200ml, 500ml, 1 litre & 5 litres.",
    field_note: "Antimicrobial first line.",
    safety: "FOR EXTERNAL USE ONLY.",
  },
  {
    id: "peuritol",
    name: "Peuritol Professional Hand Sanitizer",
    category: "clean-protect",
    species: ["biosecurity"],
    challenges: ["biosecurity"],
    image: "/catalogue/p-11.jpg",
    active_ingredient: "Antibacterial sanitizer gel",
    use_summary:
      "Clean-touch antibacterial hand sanitizer gel. For fast and effective disinfection of hands.",
    pack_sizes: "Available in multiple pack sizes — see catalogue.",
    field_note: "For clinic and field hand hygiene.",
    safety: "External use.",
  },
  {
    id: "hycolin",
    name: "Hycolin",
    category: "clean-protect",
    species: ["biosecurity"],
    challenges: ["biosecurity"],
    image: "/catalogue/p-11.jpg",
    active_ingredient:
      "Glutaraldehyde + Coco Benzyl Dimethyl Ammonium Chloride",
    use_summary:
      "Expertly cleans and disinfects surfaces. For clinics and medical facilities. Kills 99% bacteria, Mycobacteria, fungi and some yeasts. Effective on floors, walls and surfaces. Pleasant fragrance.",
    pack_sizes: "5 litre",
    field_note: "For clinics and treatment rooms.",
    safety: "Follow label directions.",
  },

  // ---------------- SKIN & UDDER CARE ----------------
  {
    id: "biosalve-milking-salve",
    name: "Biosalve Medicated Milking Salve",
    category: "skin-care",
    species: ["cattle"],
    challenges: ["udder"],
    image: "/catalogue/p-11.jpg",
    active_ingredient:
      "Benzalkonium Chloride 0.5%w/w + Lanolin 3.5%w/w + Petroleum Jelly",
    use_summary:
      "Double-action combination formula — protects and treats. Keeps udders and teats moisturised and skin supple. Prevents teat cracks and soreness — increasing milk yields. Treats dry udder skin. Rapid acting antibacterial with long lasting action. Prevents infections and mastitis.",
    pack_sizes: "2kg, 1kg, 500gm, 250gm, 100gm",
    field_note: "Use before and after milking. Safe for calves to suckle.",
    safety: "Use as directed by a veterinarian.",
    badges: ["Pre & post milking"],
  },

  // ---------------- DIGESTIVES ----------------
  {
    id: "epsom-salt",
    name: "Epsom Salt",
    category: "digestives",
    species: ["cattle", "sheep-goats"],
    challenges: ["stress"],
    image: "/catalogue/p-12.jpg",
    active_ingredient: "Magnesium Sulphate",
    use_summary: "Safe laxative in cases of constipation.",
    pack_sizes: "250gm & 500gm",
    field_note: "For veterinary use.",
    safety: "Use as directed by a veterinarian.",
  },

  // ---------------- CONSUMABLES ----------------
  {
    id: "needles-syringes",
    name: "Needles and Syringes",
    category: "consumables",
    species: ["biosecurity"],
    challenges: ["handling"],
    image: "/catalogue/p-12.jpg",
    active_ingredient: null,
    use_summary:
      "Best quality consumables for clinic and field administration.",
    pack_sizes: "Syringes 5ml, 10ml, 20ml — and matching needles.",
    field_note: "Available in clinic and field configurations.",
    safety: "Single-use sterile.",
  },

  // ---------------- ADDITIONAL ANTIMICROBIAL (from user-confirmed brand list) ----------------
  {
    id: "biotet",
    name: "BIOTET",
    category: "antibiotics",
    species: ["cattle", "sheep-goats", "poultry"],
    challenges: ["respiratory", "wounds"],
    active_ingredient: "Detailed composition available on request.",
    use_summary:
      "Tetracycline-class antimicrobial. Full product sheet available from the Biodeal Animal Health technical team.",
    pack_sizes: "Available — request from technical team.",
    field_note: "Veterinary use.",
    safety:
      "FOR VETERINARY USE ONLY. Use as directed by a veterinarian.",
    sheet_on_request: true,
  },
  {
    id: "gendex",
    name: "Gendex",
    category: "antibiotics",
    species: ["cattle", "sheep-goats", "poultry"],
    challenges: ["respiratory"],
    active_ingredient: "Detailed composition available on request.",
    use_summary:
      "Antimicrobial product. Full product sheet available from the Biodeal Animal Health technical team.",
    pack_sizes: "Available — request from technical team.",
    field_note: "Veterinary use.",
    safety:
      "FOR VETERINARY USE ONLY. Use as directed by a veterinarian.",
    sheet_on_request: true,
  },
];

export const getProductsBySpecies = (speciesId) =>
  PRODUCTS.filter((p) => p.species.includes(speciesId));

export const getProductsByChallenge = (challengeId) =>
  PRODUCTS.filter((p) => p.challenges.includes(challengeId));

export const getProductsBySpeciesAndChallenge = (speciesId, challengeId) =>
  PRODUCTS.filter(
    (p) => p.species.includes(speciesId) && p.challenges.includes(challengeId)
  );

export const getProductsByCategory = (categoryId) =>
  PRODUCTS.filter((p) => p.category === categoryId);
